var _defs, _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronIcon = function SvgChevronIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "none"
    }
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "circleOnly"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13,
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    mask: "url(#circleOnly)",
    className: "svg-background"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13,
    fill: "none",
    stroke: "#E38BB6",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.002 13.7143C19.5106 14.1147 19.5106 14.8853 19.002 15.2857L13.3686 19.7209C12.7126 20.2373 11.75 19.7701 11.75 18.9352L11.75 10.0648C11.75 9.22995 12.7126 8.76267 13.3686 9.27912L19.002 13.7143Z",
    fill: "#E38BB6"
  })));
};
export default SvgChevronIcon;